module.exports = __webpack_public_path__ + "img/title8.c52d80be.png";